import { render, staticRenderFns } from "./PaymentSidebar.vue?vue&type=template&id=1276d9f9&scoped=true"
import script from "./PaymentSidebar.vue?vue&type=script&lang=ts"
export * from "./PaymentSidebar.vue?vue&type=script&lang=ts"
import style0 from "./PaymentSidebar.vue?vue&type=style&index=0&id=1276d9f9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1276d9f9",
  null
  
)

export default component.exports